import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polyline, { points: "16 18 22 12 16 6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "8 6 2 12 8 18", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Code";
const Code = memo(themed(Icon));
export {
  Code
};
//# sourceMappingURL=code.js.map
